module.exports = __webpack_public_path__ + "static/media/emojis_18.bfc70d9e.svg";